import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatApiError } from '../lib/api';
import api from '../lib/api';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Mail, ArrowLeft, CheckCircle } from 'lucide-react';

const LOGO = '/logo.png';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-[80vh] flex items-center justify-center px-4 bg-[#F4F5F7]">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="bg-white border-2 border-[#0B1F40] p-8 brutal-shadow">
          <div className="flex flex-col items-center mb-6">
            <img src={LOGO} alt="RP" className="h-14 w-14 mb-4 border-2 border-[#0B1F40]" />
            <h1 className="text-xl text-[#0B1F40] tracking-tighter" style={{ fontFamily: 'Archivo Black' }}>RECUPERAR CONTRASEÑA</h1>
          </div>

          {sent ? (
            <div className="text-center">
              <CheckCircle className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
              <p className="text-sm text-[#0B1F40]/70 mb-2 font-bold">Revisa tu correo electrónico</p>
              <p className="text-xs text-[#0B1F40]/50 mb-6">Si el email está registrado, recibirás un enlace para restablecer tu contraseña.</p>
              <Link to="/login">
                <button className="w-full bg-[#0B1F40] text-white font-black text-sm h-10 brutal-btn-press transition-all" style={{ boxShadow: '4px 4px 0px #E50B15' }}>VOLVER AL LOGIN</button>
              </Link>
            </div>
          ) : (
            <>
              <p className="text-xs text-[#0B1F40]/50 mb-4 text-center">Ingresa tu email y te enviaremos un enlace para cambiar tu contraseña.</p>
              {error && <div data-testid="forgot-error" className="mb-4 p-3 bg-red-50 border-l-4 border-[#E50B15] text-[#E50B15] text-xs font-bold">{error}</div>}
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className="text-[10px] font-black tracking-[0.15em] uppercase text-[#0B1F40]/50">EMAIL</Label>
                  <Input data-testid="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)}
                    className="rounded-none border-2 border-[#0B1F40]/20 focus:border-[#E50B15] focus:ring-0 mt-1 h-11 font-bold" placeholder="tu@email.com" required />
                </div>
                <button data-testid="forgot-submit" type="submit" disabled={loading}
                  className="w-full bg-[#E50B15] text-white font-black text-sm h-11 flex items-center justify-center gap-2 brutal-btn-press transition-all" style={{ boxShadow: '4px 4px 0px #0B1F40' }}>
                  {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} ENVIAR ENLACE
                </button>
              </form>
              <p className="mt-4 text-center">
                <Link to="/login" data-testid="back-to-login" className="inline-flex items-center gap-1 text-xs font-black text-[#0B1F40]/40 hover:text-[#E50B15]">
                  <ArrowLeft className="h-3 w-3" /> Volver al login
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
